<script>
  import Configuration from "../../config";
  import backend from "../../server";
  import alertify from "alertifyjs";

  export let onLogin;

  let username = "";
  let password = "";

  const conf = Configuration.getConfiguration();

  const loginEnter = (e) => {
    if (e.charCode === 13) login();
  };

  const login = async () => {
    try {
      const { data } = await backend.login(username, password);
        let loginData = {
            id: data.id,
            username,
            access_token: data.access_token,
            destine: data.destine,
            role: data.rol,
            c_id: data.c_id,
            client_code: data.client_code,
        };
      onLogin(loginData);
      alertify.success("BIENVENIDO, " + username);
    } catch (error) {
      alertify.error("CREDENCIALES INCORRECTAS");
    }
  };
</script>

<div class="modal-container">
  <div class="auth">
    <h3 class="text-white">Bienvenido a BO</h3>
    <img
      width="210px"
      src="https://assets-usoft.universalsoft.net/bo_fontend/logo_small.png"
      alt=""
    />
    <div class="form-container">
      <div>
        <label class="text-white" for="username">Usuario:</label>
        <input
          id="username"
          class="form-control"
          type="text"
          on:keypress={loginEnter}
          bind:value={username}
          placeholder="Usuario"
        />
      </div>
      <div>
        <label class="text-white" for="password">Contraseña:</label>
        <input
          id="password"
          class="form-control"
          type="password"
          on:keypress={loginEnter}
          bind:value={password}
          placeholder="Contraseña"
        />
      </div>
      <button class="btn" on:click={login}>Iniciar Sesión</button>
    </div>
  </div>
</div>

<style>
  .modal-container {
    min-height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url("https://assets-usoft.universalsoft.net/bo_fontend/bggradientv2.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .auth {
    width: 350px;
    max-width: 100%;
    padding: 2rem 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    background: rgb(255 255 255 / 6%);
    border-radius: 2rem;
  }
  .auth:hover {
    box-shadow: rgba(15, 3, 10, 0.938) 0px 0px 80px 0px;
  }
  .form-container {
    width: 100%;
    margin-top: 0.8rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .form-control {
    width: 100%;
  }
  button {
    width: 100%;
    margin: 0 auto;
    background: #ff007b;
    color: white;
  }

  button:hover {
    color: white !important;
    background: linear-gradient(90deg, #ff007b 0%, #000000 100%) !important;
  }
</style>
